import { ValidUserCodeRequestPayload } from "@/data/payload/auth/valid-user-auth-token-request-payload";
import { UserPasswordManageRepository } from "@/domain/repository/user-password-reset-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class ValidUserAuthCodeUsecase {
  //MARK:- init
  constructor(private readonly userAuthCodeRepo: UserPasswordManageRepository) {}

  //MARK:- execute
  async execute(code: string, token: string): Promise<SATResult<void, SATError>> {
    const payload: ValidUserCodeRequestPayload = {
      code: code,
      token: token,
    };

    const result = await this.userAuthCodeRepo.validUserAuthCode(payload);
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }

    return SATResult.success(void 0);
  }
}
